// extracted by mini-css-extract-plugin
export default {"messages":"Messages_messages__WRnqt","empty":"Messages_empty__XB5-I"};